/** @file Thai catalog part of area E3 (W3-03): the Timeline panel strings, partial. */

/** The `timeline` panel block (spread into `panels`); partial, English fills the gaps. */
export const timelineTh = {
  timeline: {
    title: 'ไทม์ไลน์', views: 'มุมมองไทม์ไลน์', dopesheet: 'Dopesheet', toolbar: 'การเล่น', rows: 'แถวไทม์ไลน์', keys: 'คีย์ใน dopesheet',
    play: 'เล่น', pause: 'หยุดชั่วคราว', first: 'เฟรมแรก', prev: 'เฟรมก่อนหน้า', next: 'เฟรมถัดไป', last: 'เฟรมสุดท้าย', frame: 'เฟรม',
    key: 'ใส่คีย์', autoKey: 'ใส่คีย์อัตโนมัติ', clearLoop: 'วน {a}–{b} ×', noAnimation: 'เลือก animation ในแผง Animations',
    expand: 'แสดงช่องของ {name}', collapse: 'ซ่อนช่องของ {name}', drawOrder: 'ลำดับการวาด', events: 'อีเวนต์',
    channels: {
      rotation: 'หมุน', x: 'เลื่อน X', y: 'เลื่อน Y', scaleX: 'สเกล X', scaleY: 'สเกล Y', shearX: 'เฉือน X', shearY: 'เฉือน Y',
      inherit: 'การสืบทอด', attachment: 'แอตแทชเมนต์', rgb: 'สี', alpha: 'ความทึบ', dark: 'สีเข้ม', ikMix: 'IK mix',
      ikSoftness: 'IK softness', ikBend: 'IK bend', ikStretch: 'IK stretch', ikCompress: 'IK compress', deform: 'ดีฟอร์ม', drawOrder: 'ลำดับการวาด',
    },
  },
  animations: {
    title: 'แอนิเมชัน', list: 'แอนิเมชัน', empty: 'ยังไม่มีแอนิเมชัน', newName: 'ชื่อแอนิเมชันใหม่',
    open: 'เปิด {name} ในไทม์ไลน์', rename: 'ชื่อของ {name}', frames: 'จำนวนเฟรม', duplicate: 'ทำซ้ำ', remove: 'ลบ',
    mix: { title: 'ทดลองผสม', from: 'จาก', to: 'ไป', seconds: 'ผสม (วินาที)', play: 'ทดลอง', stop: 'หยุด', save: 'ตั้งเป็นค่าเริ่มต้น' },
  },
} as const;
